export const tickerItems = [
  "红毯名场面盘点热度破 900 万",
  "《夏日奔赴》收官夜观众刷屏热议",
  "某品牌新品发布话题持续霸榜 48 小时",
  "年度综艺高光片段合集本周上线",
  "复古磁带风穿搭带火一大波怀旧话题",
  "深夜食堂主题短片单日播放超 800 万",
];

export const hotData = [
  {
    title: "红毯之夜名场面逐帧复盘：谁的状态最松弛",
    tag: "娱乐",
    heat: 986,
    delta: 12,
    time: "8 分钟前",
    hot: "爆",
  },
  {
    title: "《夏日奔赴》收官录制，观众最舍不得的五个瞬间",
    tag: "综艺",
    heat: 873,
    delta: 8,
    time: "21 分钟前",
    hot: "爆",
  },
  {
    title: "这家老字号咖啡的新包装为何全网二创",
    tag: "消费",
    heat: 721,
    delta: 6,
    time: "38 分钟前",
    hot: "热",
  },
  {
    title: "一档素人节目如何把口碑做到断层第一",
    tag: "综艺",
    heat: 668,
    delta: -3,
    time: "54 分钟前",
    hot: "热",
  },
  {
    title: "国产动画新作点映，观众一致点赞画面质感",
    tag: "影视",
    heat: 604,
    delta: 4,
    time: "1 小时前",
    hot: "热",
  },
  {
    title: "复古磁带随身听的走红背后，是一代人的记忆",
    tag: "生活",
    heat: 552,
    delta: 9,
    time: "1 小时前",
    hot: "热",
  },
  {
    title: "一场演唱会串起十年青春，歌迷直呼泪目",
    tag: "音乐",
    heat: 490,
    delta: 2,
    time: "1 小时前",
    hot: "热",
  },
  {
    title: "短视频平台年度十大创意企划公开",
    tag: "行业",
    heat: 431,
    delta: -5,
    time: "2 小时前",
    hot: "议",
  },
  {
    title: "某都市剧台词集被网友剪成励志混剪",
    tag: "影视",
    heat: 388,
    delta: 7,
    time: "2 小时前",
    hot: "议",
  },
];

export const weekHotData = [
  {
    title: "本周全网讨论度最高的五件大事（超全时间线）",
    tag: "总榜",
    heat: 3204,
    delta: 0,
    time: "7 天更新",
    hot: "周冠",
  },
  {
    title: "现象级话题的诞生：从偶发到刷屏的传播复盘",
    tag: "观察",
    heat: 2780,
    delta: 0,
    time: "6 天前",
    hot: "荐",
  },
  {
    title: "品牌联名翻车与出圈，盘点那些教科书级操作",
    tag: "消费",
    heat: 2455,
    delta: 0,
    time: "6 天前",
    hot: "荐",
  },
  {
    title: "暑期档口碑黑马，为何能逆袭成为年度爆款",
    tag: "影视",
    heat: 2190,
    delta: 0,
    time: "5 天前",
    hot: "荐",
  },
  {
    title: "告别流量泡沫，这届观众到底在为什么买单",
    tag: "观察",
    heat: 1904,
    delta: 0,
    time: "5 天前",
    hot: "荐",
  },
  {
    title: "年度音乐综艺名场面合集，收藏这一篇就够",
    tag: "音乐",
    heat: 1660,
    delta: 0,
    time: "4 天前",
    hot: "荐",
  },
];

export const collections = [
  {
    id: 1,
    title: "红毯名场面全集",
    category: "娱乐盘点",
    count: 128,
    desc: "从造型惊艳到临场趣事，按场次整理全年红毯高光，一次看个够。",
    image: "https://readdy.ai/api/search-image?query=editorial%20magazine%20style%20collage%20of%20glamorous%20red%20carpet%20fashion%20moments%20with%20warm%20spotlights%20and%20vermilion%20red%20accents%2C%20cream%20paper%20texture%20background%2C%20elegant%20cinematic%20lighting&width=800&height=560&seq=gua-col-redcarpet&orientation=landscape",
  },
  {
    id: 2,
    title: "综艺高光时刻",
    category: "综艺档案",
    count: 216,
    desc: "舞台名场面、幕后彩蛋与名场面剪辑，把追过的综艺一网打尽。",
    image: "https://readdy.ai/api/search-image?query=colorful%20concert%20stage%20lights%20with%20cheering%20audience%20silhouettes%20in%20warm%20coral%20and%20gold%20tones%2C%20editorial%20event%20photography%2C%20lively%20yet%20premium%20magazine%20aesthetic&width=800&height=560&seq=gua-col-variety&orientation=landscape",
  },
  {
    id: 3,
    title: "社会热议风向标",
    category: "话题观察",
    count: 342,
    desc: "聚焦城市生活、消费与职场热议，梳理观点碰撞与讨论脉络。",
    image: "https://readdy.ai/api/search-image?query=modern%20city%20skyline%20at%20dusk%20with%20warm%20amber%20window%20lights%20and%20subtle%20newspaper%20texture%20overlay%2C%20editorial%20documentary%20photography%2C%20thoughtful%20journalistic%20mood&width=800&height=560&seq=gua-col-society&orientation=landscape",
  },
  {
    id: 4,
    title: "影视剧话题簿",
    category: "剧集观察",
    count: 189,
    desc: "热剧台词、角色名场面与幕后花絮，追剧人的完整收藏夹。",
    image: "https://readdy.ai/api/search-image?query=cinema%20film%20reel%20and%20clapperboard%20on%20warm%20cream%20desk%20with%20golden%20and%20vermilion%20props%2C%20editorial%20behind%20the%20scenes%20photography%2C%20cozy%20retro%20studio%20mood&width=800&height=560&seq=gua-col-drama&orientation=landscape",
  },
  {
    id: 5,
    title: "音乐现场名场面",
    category: "音乐档案",
    count: 154,
    desc: "从演唱会到音乐节，收藏那些让全场大合唱的经典瞬间。",
    image: "https://readdy.ai/api/search-image?query=live%20concert%20stage%20with%20warm%20orange%20and%20amber%20beams%20and%20silhouetted%20crowd%20singing%20along%2C%20editorial%20music%20festival%20photography%2C%20emotional%20atmospheric%20lighting&width=800&height=560&seq=gua-col-music&orientation=landscape",
  },
  {
    id: 6,
    title: "消费潮流观察",
    category: "行业追踪",
    count: 97,
    desc: "新消费、复古风与联名潮流的来龙去脉，看懂年轻人为什么买单。",
    image: "https://readdy.ai/api/search-image?query=retro%20cassette%20player%20and%20sneakers%20arranged%20artfully%20on%20warm%20cream%20backdrop%20with%20gold%20and%20coral%20accents%2C%20editorial%20product%20photography%2C%20trendy%20minimalist%20styling&width=800&height=560&seq=gua-col-trend&orientation=landscape",
  },
];

export const timeline = [
  {
    period: "2026 年 9 月",
    events: [
      { date: "09.06", title: "红毯之夜名场面持续发酵", tag: "娱乐", desc: "造型、互动与花絮逐帧复盘，相关话题连续霸榜，编辑部同步更新逐场合集。" },
      { date: "09.03", title: "现象级短片刷屏", tag: "生活", desc: "一支复古磁带主题短片单日播放破 800 万，带动怀旧消费浪潮被广泛讨论。" },
    ],
  },
  {
    period: "2026 年 8 月",
    events: [
      { date: "08.28", title: "综艺收官夜口碑断层", tag: "综艺", desc: "《夏日奔赴》收官，五个名场面入选高光档案，观众二创热情空前。" },
      { date: "08.21", title: "国漫新作点映获赞", tag: "影视", desc: "画面质感与剧本获得一致好评，被预测为暑期档口碑黑马。" },
      { date: "08.15", title: "品牌二创出圈", tag: "消费", desc: "老字号新包装引发全网二创，复盘其传播路径成为现象级案例。" },
    ],
  },
  {
    period: "2026 年 7 月",
    events: [
      { date: "07.19", title: "演唱会串起十年青春", tag: "音乐", desc: "一场巡演大合唱刷屏社交网络，歌迷集体「爷青回」引发共鸣。" },
      { date: "07.06", title: "年度创意企划公开", tag: "行业", desc: "平台发布年度十大创意企划，编辑部整理完整幕后档案并持续更新。" },
    ],
  },
];

export const featured = [
  {
    id: 1,
    title: "全网最全红毯名场面逐帧复盘",
    tag: "娱乐盘点",
    readTime: 9,
    excerpt: "从红毯造型到台下趣事，按出场顺序逐段还原，附完整高清动图档案与背景解读。",
    image: "https://readdy.ai/api/search-image?query=elegant%20evening%20gown%20detail%20on%20warm%20red%20carpet%20with%20golden%20bokeh%20lights%20and%20flash%20photography%20glare%2C%20editorial%20celebrity%20event%20magazine%20photography%2C%20premium%20warm%20toned&width=800&height=500&seq=gua-feat-redcarpet&orientation=landscape",
  },
  {
    id: 2,
    title: "一档素人节目凭什么口碑断层第一",
    tag: "综艺观察",
    readTime: 7,
    excerpt: "拆解节目从选角到剪辑的每一步取舍，看看观众真正愿意留下的理由。",
    image: "https://readdy.ai/api/search-image?query=television%20studio%20set%20with%20warm%20stage%20lights%20and%20comfy%20armchairs%2C%20editorial%20behind%20the%20scenes%20photography%2C%20cozy%20amber%20and%20cream%20palette%2C%20documentary%20style&width=800&height=500&seq=gua-feat-variety&orientation=landscape",
  },
  {
    id: 3,
    title: "现象级话题的传播脉络，一篇看懂",
    tag: "话题观察",
    readTime: 6,
    excerpt: "从偶发到刷屏，用一条清晰的时间线还原话题是如何一步步走向全网的。",
    image: "https://readdy.ai/api/search-image?query=abstract%20network%20of%20glowing%20amber%20connection%20lines%20over%20warm%20dark%20red%20background%20with%20soft%20particles%2C%20editorial%20data%20visualization%2C%20premium%20warm%20toned%20graphic&width=800&height=500&seq=gua-feat-spread&orientation=landscape",
  },
  {
    id: 4,
    title: "暑期档口碑黑马的逆袭逻辑",
    tag: "影视解析",
    readTime: 8,
    excerpt: "从排片到口碑，复盘一部原本不被看好作品如何凭借口碑完成逆袭。",
    image: "https://readdy.ai/api/search-image?query=cinema%20theater%20rows%20with%20soft%20warm%20projector%20light%20beam%20and%20film%20grain%2C%20editorial%20movie%20review%20photography%2C%20warm%20retro%20theater%20ambiance&width=800&height=500&seq=gua-feat-blackhorse&orientation=landscape",
  },
  {
    id: 5,
    title: "复古磁带风：一代人记忆的集体回响",
    tag: "生活趋势",
    readTime: 5,
    excerpt: "怀旧经济为什么总能让年轻人买单？我们梳理了复古潮流背后的情感逻辑。",
    image: "https://readdy.ai/api/search-image?query=vintage%20cassette%20tapes%20and%20walkman%20scattered%20on%20warm%20cream%20background%20with%20golden%20sunlight%20and%20coral%20accent%20details%2C%20editorial%20retro%20product%20photography&width=800&height=500&seq=gua-feat-retro&orientation=landscape",
  },
  {
    id: 6,
    title: "年度综艺高光片段全收藏",
    tag: "综艺档案",
    readTime: 4,
    excerpt: "舞台名场面、金句与幕后彩蛋一次收齐，收藏这一篇，回看再也不翻车。",
    image: "https://readdy.ai/api/search-image?query=collage%20of%20bright%20concert%20confetti%20and%20sparklers%20in%20warm%20gold%20and%20coral%20tones%20on%20cream%20paper%2C%20editorial%20celebration%20photography%2C%20joyful%20premium%20mood&width=800&height=500&seq=gua-feat-highlight&orientation=landscape",
  },
];

export const downloadSteps = [
  { step: "01", title: "浏览合集", desc: "在热榜、合集与时间线中挑选你感兴趣的主题。" },
  { step: "02", title: "一键整理", desc: "批量勾选后，系统自动将精华内容打包归拢成资源包。" },
  { step: "03", title: "打包带走", desc: "导出为离线合集，随时随地方便回看，不错过任何细节。" },
];

export const testimonials = [
  {
    name: "追剧小周",
    role: "娱乐爱好者",
    text: "找红毯名场面合集翻遍全网，最后还是在这里一次看全，时间线排得特别清楚。",
  },
  {
    name: "阿澈",
    role: "内容从业者",
    text: "按时间线梳理事件脉络这个思路太实用了，做选题参考基本离不开它。",
  },
  {
    name: "蘑菇不挑食",
    role: "老粉",
    text: "从刚开站就在追，更新快、整理全，打包下载功能救了我手机相册的命。",
  },
];

export const faqs = [
  {
    q: "呱呱爆料的合集多久更新一次？",
    a: "热榜与话题内容每天滚动更新，重点合集一般在新事件发酵后的 1-2 天内完成归档，编辑部会按时间线持续补充后续进展，确保你不错过任何关键细节。",
  },
  {
    q: "历史记录和精华内容有什么区别？",
    a: "历史记录按事件发生的时间先后整理，方便你追溯来龙去脉；精华内容则挑选传播最广、讨论度最高的名场面与名句，适合快速上手补课。两者可以配合使用。",
  },
  {
    q: "打包下载是否收费？",
    a: "绝大多数公开合集的在线浏览免费。打包下载功能支持把选中的内容整理成离线资源包，具体权益以资源包说明为准，新用户常会有体验额度。",
  },
  {
    q: "下载后的文件能在手机上直接打开吗？",
    a: "可以。打包内容以常见格式输出，手机和电脑均可直接打开查看。如果遇到打不开的情况，可在帮助与反馈中告诉我们，编辑部会尽快协助处理。",
  },
  {
    q: "我可以投稿或纠错吗？",
    a: "非常欢迎。若你发现某条整理存在遗漏或偏差，可通过站内反馈告诉我们。编辑部会对信息进行复核，确认后在对应合集内更新并标注修正说明。",
  },
];